import { UploadOutlined } from '@ant-design/icons'
import { Progress } from 'antd'

function FileUploaderBody({
  isLoading,
  isSuccess,
  filename,
  filenamePlaceholder = '',
  hintText = '',
}: {
  isLoading?: boolean
  isSuccess?: boolean
  filename?: string
  filenamePlaceholder?: string
  hintText?: string
}): JSX.Element {
  return (
    <div className="bg-transparent rounded-lg border-dashed border border-gray-300 hover:!border-gray-200 p-0 py-4">
      {isLoading || isSuccess ? (
        <Progress
          percent={isSuccess ? 100 : 0}
          size={60}
          type="dashboard"
          status="normal"
          strokeColor="#3E54B8"
          className="[&>.ant-progress-body>.ant-progress-indicator]:text-primary-600"
        />
      ) : (
        <p className="ant-upload-drag-icon !mb-2">
          <UploadOutlined className="!text-gray-400 h-[66px]" />
        </p>
      )}
      <p className="ant-upload-text">
        {filename ? filename : filenamePlaceholder}
      </p>
      <p className="ant-upload-hint">
        {isLoading
          ? 'File is uploading...'
          : isSuccess
            ? 'File uploaded successfully.'
            : hintText}
      </p>
    </div>
  )
}

export default FileUploaderBody
